import fitmentSearch from './fitmentSearch';
import klaviyo from './klaviyo';
import specifyVehicle from './specifyVehicle';

export default [fitmentSearch, specifyVehicle, klaviyo];
